import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { AuthGuard } from './_guards/auth.guard';
import { P404Component } from './_directives/error/404.component';
import { ApplicationFtsLivePreviewComponent } from './_directives/application-fts-live-preview/application-fts-live-preview.component';
import { OrderGenerationGuard } from './_guards/order-generation.guard';
import { MyAccountComponent } from './modules/profile/my-account/my-account.component';
import { UserModuleGuard } from './_guards/user-module.guard';
import { StatisticalOfficerGuard } from './_guards/statistical-officer.guard';
import { FacilitationCentreGuard } from './_guards/facilitation-centre.guard';
import { ReportingModuleGuard } from './_guards/reporting-module.guard';
import { PSOfficerGuard } from './_guards/ps-officer.guard';
import { RiBranchGuard } from './_guards/ri-branch.guard';
import { P401Component } from './_directives/error/401.component';
import { PrintItComponent } from './_directives/print-it.component';
import { DepartmentFTSReportComponent } from './_directives/department-fts-report/department-fts-report.component';
import { ReportingComponent } from './portal/online-posting/reporting/reporting.component';
import { ReportingSMOComponent } from './portal/online-post-apply/reporting/reporting.component';
import { ReportingApplicationComponent } from './portal/online-application/reporting/reporting.component';
import { CitizenPortalGuard } from './_guards/citizen-portal.guard';
import { MapsComponent } from './modules/dashboard/maps/maps.component';
import { PostingComponent } from './portal/online-posting/posting/posting.component';
import { CEOApplicationGuard } from './_guards/ceo-application.guard';
import { PHFMCHrGuard } from './_guards/phfmc-hr.guard';
import { AdminAuthGuard } from './_guards/adminAuth.guard';
import { CovidDashboardComponent } from './modules/dashboard/covid-dashboard/covid-dashboard.component';
import { PromotionApplicationComponent } from './portal/public-portal-mo/promotion-application/promotion-application.component';
import { PromotionApplicationListStartComponent } from './portal/public-portal-mo/promotion-application/promotion-application-list-start/promotion-application-list-start.component';
import { PromotionApplicationListDetailComponent } from './portal/public-portal-mo/promotion-application/promotion-application-list-detail/promotion-application-list-detail.component';
import { DepartmentFTSPendancyComponent } from './_directives/department-fts-pendancy/department-fts-pendancy.component';
import { AwaitingPostingComponent } from './portal/online-posting/awaiting-posting/awaiting-posting.component';
import { ConsultantPromoComponent } from './portal/online-posting/consultant-promo/consultant-promo.component';
import { DesignationMapComponent } from './modules/dashboard/designation-map/designation-map.component';
import { JobPostingComponent } from './portal/public-portal/posting/posting.component';
import { OrdersComponent } from './portal/public-portal/orders/orders.component';
import { DepartmentFTSPendancyTableComponent } from './_directives/department-fts-pendancy-table/department-fts-pendancy-table.component';
import { AdhocPostingComponent } from './modules/adhoc/adhoc-posting/adhoc-posting.component';
import { AdhocApplicantWorkingPaperComponent } from './modules/adhoc/adhoc-applicant-working-paper/adhoc-applicant-working-paper.component';
import { AdhocApplicantWPSComponent } from './modules/adhoc/adhoc-applicant-wps/adhoc-applicant-wps.component';
import { AdhocApplicantWRPSComponent } from './modules/adhoc/adhoc-applicant-wrps/adhoc-applicant-wrps.component';
import { AdhocMeritComponent } from './modules/adhoc/adhoc-merit/adhoc-merit.component';
import { AdhocAdminGuard } from './_guards/adhoc-admin.guard';
import { AdhocMeritPostingComponent } from './modules/adhoc/adhoc-merit-posting/adhoc-merit-posting.component';
import { PUCDashboardComponent } from './_directives/puc-dashboard/puc-dashboard.component';
import { VacancyChartsMapComponent } from './modules/dashboard/vacancy-charts-map/vacancy-charts-map.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'HouseJob',
    pathMatch: 'full',
  },
  {
    path: 'account',
    loadChildren: './account/account.module#AccountModule',
    data: { title: 'Login' }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: { title: 'Home' },
    children: [
      {
        path: 'dashboard',
        loadChildren: './modules/dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuard],
        data: { title: 'Dashboard' }
      },
      
      {
        path: 'adhoc-applications',
        loadChildren: './modules/adhoc/adhoc.module#AdhocModule',
        canActivate: [AuthGuard],
        data: { title: 'Adhoc Applications' }
      },
      {
        path: 'p',
        loadChildren: './modules/promotion/promotion.module#PromotionModule',
        canActivate: [AuthGuard],
        data: { title: 'Promotion Applications' }
      },
      {
        path: 'user',
        loadChildren: './modules/user/user.module#UserModule',
        canActivate: [AuthGuard, UserModuleGuard],
        data: { title: 'User' }
      },
      {
        path: 'helpline',
        loadChildren: './modules/helpline/helpline.module#HelplineModule',
        canActivate: [AuthGuard],
        data: { title: 'Helpline' }
      },
     
    ]
  },
 
  {
   path: 'adhoc-merit-wp', component: AdhocMeritComponent, canActivate: [AdhocAdminGuard]
  }, 
  
  { path: '401', component: P401Component, canActivate: [AuthGuard], data: { title: 'Unauthorized' } },
  { path: 'puc-dashboard', component: PUCDashboardComponent, canActivate: [AuthGuard], data: { title: 'PUC Dashboard' } },
  { path: 'department-report', component: DepartmentFTSReportComponent, canActivate: [AuthGuard], data: { title: 'P&S Department' } },
  { path: 'department-pendancy', component: DepartmentFTSPendancyComponent, canActivate: [AuthGuard], data: { title: 'P&S Department' } },
  { path: 'department-pendency', component: DepartmentFTSPendancyComponent, canActivate: [AuthGuard], data: { title: 'P&S Department' } },
  { path: 'department-pendency-table', component: DepartmentFTSPendancyTableComponent, canActivate: [AuthGuard], data: { title: 'P&S Department' } },
  { path: 'promotion-form', component: PromotionApplicationComponent, data: { title: 'MO/WMO to Consultant' } },
  {
    path: 'main',
    loadChildren: './portal/public-portal/public-portal.module#PublicPortalModule',
    data: { title: 'Public Portal' }
  },
 
  {
    path: 'HouseJob',
    loadChildren: './portal/online-adhoc/online-adhoc.module#OnlineAdhocModule',
    data: { title: 'HouseJob' }
  },
  
  { path: '**', component: P404Component, data: { title: 'Not Found' } }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
